<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <formEdit :key="componentKey" :mode="mode" @back="backToList" @save="saveData" :triggerSave.sync="triggerSave"
          :model="models" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add'

export default {
  components: {
    formEdit
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'Reviews', to: '/admin/list-reviews' },
        { label: '' }
      ],
      users: null,
      validationErrors: [],
      title: "Create A Review",
      mode: 'add',
      models: {},
      componentKey: 1,
      accountID: '',
      page_transaction: null,
      active_check: true,
      time_zone_local: moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted() {
    this.mode = this.$route.name === 'edit' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit' : this.title;
    this.items_bread_crumb[1].label = this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_REVIEWS);
    if (this.mode == 'edit') {
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    } else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    }
    this.componentKey = (new Date()).getTime();
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-reviews' });
    },
    async saveData(params) {
      var list_file = params?.list_file ?? [];
      var list_file_edit = params?.list_file_edit ?? [];
      var list_id_file_delete = params?.list_id_file_delete ?? [];
      let objects = {};
      this.triggerSave = false;
      if (this.mode === 'add') {
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;

        try {
          let resBanner = await this.$apollo.mutate({
            mutation: DataServices.insertData('reviews'),
            variables: {
              objects: {
                author: params?.author ?? "",
                stars: String(params?.stars) ?? "",
                comment: params?.comment ?? "",
                active: params?.active ?? null,
                updated_at: moment.tz(new Date(), this.time_zone_local),
                created_by: this.$store.getters.user,
                ordinal : params?.ordinal ?? 0,
              },
            }
          });
          let returningBanner = resBanner.data[Object.keys(resBanner.data)].returning[0];
          if (list_file.length > 0) {
              let resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.REVIEWS_AUTHOR, list_file);
              if (resImage && resImage.length > 0) {
                for (let i = 0; i < resImage.length; i++) {
                  let objectImage = resImage[i];
                  await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.REVIEWS_AUTHOR, returningBanner.id, objectImage).catch(async error => {
                    console.log('error', error);
                    this.$toast.add({
                      severity: 'error',
                      summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                      detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                      life: 3000
                    });
                  });
                }
              }
          }
          this.redirectEdit();

        } catch (error) {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
          this.$commonFuction.is_loading(false);
        }
      }
      else if (this.mode === 'edit') {
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;
        try {
          let resBanner = await this.$apollo.mutate({
            mutation: DataServices.updateData('reviews'),
            variables: {
              'data_update': {
                author: params?.author ?? "",
                stars: String(params?.stars) ?? "",
                comment: params?.comment ?? "",
                active: params?.active ?? null,
                updated_at: moment.tz(new Date(), this.time_zone_local),
                ordinal : params?.ordinal ?? 0,
              },
              'where_key': {
                'id': { '_eq': this.models.id }
              }
            }
          });

          let returningBanner = resBanner.data[Object.keys(resBanner.data)].returning[0];
          if (list_id_file_delete.length > 0) {
            await this.$CoreService.deleteDataImageMulti(this.$constants.TYPE_IMAGE.REVIEWS_AUTHOR, list_id_file_delete)
            await this.$CoreService.deleteDataImage(this.$constants.TYPE_IMAGE.REVIEWS_AUTHOR, returningBanner.id);
          }
          if (list_file.length > 0) {
            if (list_file_edit.length > 0) {
              await this.$CoreService.deleteDataImage(this.$constants.TYPE_IMAGE.REVIEWS_AUTHOR, this.models.id);
            }
            const resImage = await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.BANNER, list_file);
            if (resImage && resImage.length > 0) {
              for (let i = 0; i < resImage.length; i++) {
                var image = resImage[i];
                await this.$CoreService.updateDataImage(this.$constants.TYPE_IMAGE.REVIEWS_AUTHOR, returningBanner.id, image).catch(async error => {
                  console.log('error', error);
                  this.$toast.add({
                    severity: 'error',
                    summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                    life: 3000
                  });
                });
              }
            }
          }
          this.redirectEdit();
        } catch (error) {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
        }
      }
      this.$commonFuction.is_loading(false);
      this.$commonFuction.is_loading(false);
    },
    async redirectEdit() {
      var that = this;
      var router_back = { path: '/admin/list-reviews' };
      that.$commonFuction.is_loading(false);
      if (that.mode == 'add') {
        that.$router.push(router_back);
      } else {
        if (!that.$commonFuction.isEmpty(router_back)) {
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var { data } = await this.$apollo.query({
        query: DataServices.getList('reviews'),
        variables: {
          where_key: {
            id: { '_eq': id }
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var dataImage = await this.$CoreService.getFileMapFile([this.$constants.TYPE_IMAGE.REVIEWS_AUTHOR], [this.models.id]);
        var dataImageList = await this.$CoreService.getFileMapFile([this.$constants.TYPE_IMAGE.REVIEWS_AUTHOR], [this.models.id]);
        this.models["list_file_edit"] = dataImage.listData;
        this.models["list_file_edit_normal"] = dataImageList.listData;

      }
      this.componentKey++;
    },
  },
  apollo: {

  }
}
</script>

<style lang="scss">
.manager-title-custom {
  color: #1D3118;
  font-size: 24px !important;
  padding-bottom: 20px;
  font-weight: 700;
  margin-left: 20px;
}
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only {
      padding: 0 !important;
    }
  }
}
.note {
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: 24px;
  padding-top: 10px;
}
.p-formgrid {
  margin: 0;
  .p-panel-header {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
    background: #EEEEEE;
  }
  .p-card-field {
    padding: 24px;
    .p-field {
      .p-col-fixed {
        width: 300px;
        display: inline-block !important;
        margin: 0;
      }
      .p-col-width {
        width: 500px !important;
        border-radius: 5px;

        &.disabled {
          background: #EEEEEE;
          border: 0 none;
          padding: 8px 10px;
        }

        .file-select {
          margin: 0;

          input[type="file"] {
            display: none;
          }

          .select-button {
            display: inline-block;
            cursor: pointer;
            background: transparent;
            border-radius: 5px;
            color: #000000;
            font-size: 13px;
            padding: 3px 16px;
            border: 1px solid #B4B4B4;
          }
        }

        &.pac-target-input {
          height: 80px;
          word-break: break-all;
          overflow-wrap: break-word;
          resize: none;
        }
      }

      .box-images {
        margin: 0;
        margin-top: 10px;
        position: relative;

        .item-img {
          width: 150px;
          height: 150px;
          margin-right: 8px;
          margin-bottom: 8px;
          display: inline-flex;
          position: relative;

          img {
            max-width: 100%;
            height: auto;
            margin: 0 auto;
            object-fit: contain;
            padding: 5px;
          }

          .button-clear {
            border-radius: 10px;
            width: 24px;
            height: 24px;
            background: #F5564E;
            float: right;
            cursor: pointer;
            position: absolute;
            right: 0px;

            img {
              vertical-align: top;
            }
          }
        }
      }

      .p-invalid {
        display: block;
      }
    }
  }

  .fixed-bottom-toolbar {
    background: transparent;
    border: 0 none;
    margin-top: 22px;
    border-top: 1px solid #B4B4B4;
    padding: 0;
    padding-top: 30px;

    .p-button {
      width: auto;
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.manager-title-row {
  border-bottom: 1px solid #EEEEEE;
}

.p-toolbar-group-right {
  flex-basis: 30%;
}

.p-button-warning.p-button {
  margin: 0 10px;
}
</style>
